
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tg-reward",
      function () {
        return require("private-next-pages/tg-reward/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tg-reward"])
      });
    }
  